export class ButtonElement {
  constructor(element) {
    this.element = element;
    this.cacheTimeout = 60 * 60 * 1000; // 60 mins

    if (!element) {
      return;
    }

    this.processGithubReleaseLinks();
  }

  async processGithubReleaseLinks() {
    const releaseAttribute = this.element.dataset.githubRelease;

    if (!releaseAttribute) return;

    try {
      const release = JSON.parse(releaseAttribute);
      if (release && release.filename) {
        try {
          const data = await this.rebuildApiLinks(release);
          this.findAndReplaceLink(release, data);
        } catch (error) {
          console.error("Error fetching GitHub release data:", error);
        }
      }
    } catch (e) {
      console.error("Error parsing GitHub release data:", e);
    }
  }

  async rebuildApiLinks(release) {
    const apiUrl = `https://api.github.com/repos/${release.owner}/${release.repository}/releases/latest`;
    const cacheKey = `cache-learn-${this.element.id}`;

    // Check sessionStorage cache first
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      try {
        const parsedCache = JSON.parse(cached);
        if (parsedCache.timestamp && Date.now() < parsedCache.timestamp) {
          return parsedCache.data;
        }
      } catch (e) {
        console.warn("Error parsing cached data:", e);
      }
    }

    // Fetch fresh data if cache is invalid or missing
    try {
      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`GitHub API request failed: ${response.status}`);
      }

      const data = await response.json();

      // Update cache
      sessionStorage.setItem(
        cacheKey,
        JSON.stringify({
          timestamp: Date.now() + this.cacheTimeout,
          data: data,
        }),
      );

      return data;
    } catch (error) {
      console.error("Failed to fetch GitHub release data:", error);
      throw error;
    }
  }

  findAndReplaceLink(release, githubResponse) {
    let filename = release.filename;
    // Replace the asterisk with a check for any non-whitespace character
    // from: "adafruit_drivers_*.exe"
    // to: /^(adafruit_drivers_){1}[\S]+(.exe){1}$/g
    filename = filename
      .split("*")
      .map((value) => {
        return "(" + value + "){1}";
      })
      .join("[\\S]+");

    filename = "^" + filename + "$";
    const regexp = new RegExp(filename, "g");

    githubResponse.assets.forEach((asset) => {
      if (asset.name.match(regexp)) {
        // Replace the button link with the actual download link of the latest file
        const link = this.element.querySelector("a");
        if (link) {
          link.setAttribute("href", asset.browser_download_url);
        }
      }
    });
  }
}

export function initializeButtonElements(selector) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((element) => new ButtonElement(element));
}
